export type LayoutMode = LayoutModes.Grid | LayoutModes.List;

export enum LayoutModes {
  Grid = 'grid',
  List = 'list',
}
